var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__main"},[_c('div',{staticClass:"content__container"},[_c('div',[_c('span',{staticClass:"content__title"},[_vm._v(_vm._s(_vm.contentDetailData.contentName))])]),_c('div',[_c('div',{staticStyle:{"height":"fit-content"},domProps:{"innerHTML":_vm._s(_vm.contentDetailData.contentText)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }